module.exports = __webpack_public_path__ + "img/btn-ladderbarrel@1x.ad6a446e.png";